import { createSlice } from '@reduxjs/toolkit';
import { defaultGenericState, GenericState } from '../model';
import { addGenericStateSingleBuilders } from '../slice';
import { checkVerifyStatus } from './VerifyApi';
import { VerifyStatus } from './VerifyTypes';

export interface VerifyStatusState extends GenericState<VerifyStatus> {
}

export const verifyStatusSlice = createSlice({
    name: 'VerifyStatus',
    initialState: defaultGenericState,
    reducers: {
        resetVerifyStatus: () => defaultGenericState,
    },
    extraReducers: builder => {
        addGenericStateSingleBuilders(builder, checkVerifyStatus);
    },
});

export const { resetVerifyStatus } = verifyStatusSlice.actions;
